import { Store } from 'vuex'
import Router from 'vue-router'

import authStore from './store'

export default async function preRegister (_: Router, store: Store<any>) {
  await store.registerModule('auth', authStore)
}
